import { styled } from '@material-ui/core';

const getColourFromVariant = (variant, theme) => {
  switch (variant) {
    case 'error':
      return theme.palette.common.error;
    case 'negative':
      return theme.palette.common.negative;
    case 'warning':
      return theme.palette.common.warning;
    case 'success':
      return theme.palette.common.success;
    case 'slighter':
      return '#b3b3b3'; //Todo - Replace with color nobel
    default:
      return theme.palette.common.info;
  }
};

export const TagContainer = styled('span')(({ theme, variant }) => ({
  border: `1px solid ${getColourFromVariant(variant, theme)}`,
  borderRadius: '6px',
  color: getColourFromVariant(variant, theme),
  backgroundColor: theme.palette.common.white,
  fontSize: '12px',
  padding: '2px 4px 3px 4px',
}));
